import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import * as styled from 'styled-components';

import Loading from './containers/Loading';
import Error404 from './containers/Error404';

import i18n from '@/locales/i18n';

import store from '@/redux/store';

import PATH from '@/utils/path';

const GlobalStyle = styled.createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Alata&display=swap');

  body {
    margin: unset;

    font-family: 'Microsoft JhengHei', '微軟正黑體', -apple-system, BlinkMacSystemFont,
      'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .grecaptcha-badge {
    visibility: hidden;
  }
`;

const App = lazy(() => import('@/containers/App' /* webpackChunkName:"App" */));

const gtmSetUp = ((w, d, s, l, i) => {
  w[l] = w[l] || []; w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s);
  const dl = l !== 'dataLayer' ? `&l=${l}` : ''; j.async = true; j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`; f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-T3W2T93');

// const gtmCreate = () => {
//   const script = document.createElement('script');
//   script.nonce = 'nonce-y94hk4g4==';
//   script.id = 'gtm-script';
//   script.addEventListener('load', gtmSetUp);
//   document.body.appendChild(script);
// };

// useEffect(() => {
//   const parent = document.querySelector('body');
//   const targetScript = document.getElementById('gtm-script');
//   if (targetScript) {
//     parent.removeChild(targetScript);
//   }
//   gtmCreate();
// }, []);

const Main = () => (
  <Router>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route
              exact
              path={PATH.Root}
              // render={() => <Redirect to="zh-TW" />}
              render={() => <Redirect to={PATH.Home} />}
            />
            <Route path={PATH.Home} component={App} />
            <Route path="*" component={Error404} />
          </Switch>
        </Suspense>
      </I18nextProvider>
    </Provider>
  </Router>
);

render(
  <>
    {/* <React.StrictMode> */}
    <GlobalStyle />
    <Main />
    {/* </React.StrictMode> */}
  </>,
  document.getElementById('root'),
);
